export const AUTH_INFORMATION = "authInformation";
export const SIMULATION_CREATED = "simulationCreated";
